import { LoadingButton, LoadingButtonProps } from "@mui/lab";
import { Button, ButtonProps, SxProps } from "@mui/material";
import { grey } from "@mui/material/colors";
import { FC } from "react";

type Props = (ButtonProps | LoadingButtonProps) & {
  muiType?: "loading" | "normal";
  component?: React.ElementType;
  muiStyleOverride?: SxProps;
  children: React.ReactNode;
};

export const ContainedButton: FC<Props> = ({
  children,
  muiType = "normal",
  muiStyleOverride = {} as SxProps,
  ...rest
}) => {
  const style: SxProps = {
    fontWeight: "700",
    borderRadius: "20px",
    textTransform: "none",
    letterSpacing: "0.75px",
    paddingInline: "30px",
    paddingLeft: "30px",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: grey[800],
      boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
    },
    ...muiStyleOverride,
  };

  return muiType === "loading" ? (
    <LoadingButton variant="contained" sx={style} {...rest}>
      {children}
    </LoadingButton>
  ) : (
    <Button variant="contained" sx={style} {...rest}>
      {children}
    </Button>
  );
};
